'use client'
import React, { useState, useEffect } from 'react';
import { SelectColumn } from "@hrms/hrms-components";
import { classNames } from 'primereact/utils';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Tag } from 'primereact/tag';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import axios from 'axios';
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import PreviewIcon from '@mui/icons-material/Preview';
import Button from '@mui/material/Button';
import dynamic from 'next/dynamic';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from '@mui/icons-material/FindInPage';

const HrmsDataGrid = dynamic(
  () => import('@hrms/hrms-components').then((mod) => mod.HrmsDataGrid),
  { ssr: false }
);

const API_URL = process.env.NEXT_PUBLIC_API_URL;
const employeeId = 1;

export default function EmailTemplates(props) {
    const [filters, setFilters] = useState({
        TemplateName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        Templatemodule: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        WorkflowId: { value: null, matchMode: FilterMatchMode.IN },
        TemplateType: { value: null, matchMode: FilterMatchMode.EQUALS },
        isactive: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [loading, setLoading] = useState(true);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [representatives] = useState([]);
    const [statuses] = useState(['unqualified', 'qualified', 'new', 'negotiation', 'renewal']);

    useEffect(() => {
        axios.get(API_URL + "templates").then(result => {
            props.setEmailTemplates(result.data)
            setLoading(false)
        })
    }, []); 

    const handleSelectionChange = (selected) => {
      props.setSelectedRows(selected);
  };

    const columns = [
      SelectColumn,
        {   key: 'Templateid', 
            name: '', 
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, },
        {   key: 'TemplateName', 
            name: 'Name',   
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, },
        {   key: 'Templatemodule', 
            name: 'Module',   
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, },
        {   key: 'WorkflowName', 
            name: 'Workflow',   
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, },
        {   key: 'TemplateType', 
            name: 'Type',   
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, 
        },
        {   key: 'isactive', 
            name: 'Active',   
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, 
        },
        {   key: 'TemplateidEdit', 
            name: 'Edit',   
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, 
            renderCell: (params: any) => {
                const row = params.row;            
                return (
                  <Tooltip
                    title="Edit" 
                    arrow
                  >
                    <span>
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          props.getTemplateToEdit(e, row)
                        }}
                        aria-label="Edit Icon"
                        size="small"
                      >
                        <EditIcon fontSize="small" />

                      </IconButton>
                    </span>
                  </Tooltip>
                );
              } 
                   },
        {   key: 'TemplateidPreview', 
            name: 'Preview',   
            minWidth: 30,
            resizable: true,
            sortable: false,
            filterable: false, 
            renderCell: (params: any) => {
                const row = params.row;            
                return (
                  <Tooltip
                    title="Preview" 
                    arrow
                  >
                    <span>
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          props.getTemplateToPreview(e, row)
                        }}
                        aria-label="Preview Icon"
                        size="small"
                      >
                        <FindInPageIcon fontSize="small" />

                      </IconButton>
                    </span>
                  </Tooltip>
                );
              } 
        },
    ];
    
    return (
        <div className="card">
            <HrmsDataGrid
                rowHeight={60}
                rowKeyGetter={(row) => row.Templateid}
                keyExpr={(row) => row.Templateid}
                columns={columns}
                rows={props.emailTemplates}
s               employeeId={employeeId}
                loading={false}
                apiUrl={API_URL}
                selectionMode="multiple"
                selectedRows={props.selectedRows}
                onSelectedRowsChange={handleSelectionChange}
                use={{
                    configuration: false,
                    columnGroup: false,
                    columnFreeze: false,
                    export: false,
                    filter: false,
                    filterRow: false,
                    headerFilter: false,
                    columnVisibility: false,
                    rowSelection: true,
                    }}  
            />
        </div>
    );
}